import { makeStyles } from "@material-ui/core/styles";
import {
  PrimaryColor,
  White,
  LightPrimaryColor,
  Black,
  InputColor,
  LightGrey,
  DarkGrey,
} from "../../../shared/styles/colors";

export default makeStyles(() => ({
  modalHeader: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 640px)": {
      alignItems: "center",
    },
  },
  modalTitle: {
    color: Black,
    fontSize: "1.3rem",
    fontWeight: "700",
  },
  headerSubDiv: {
    display: "flex",
    flexDirection: "row",
  },
  headerButton: {
    width: "100%",
    textTransform: "none",
    border: "none",
    color: White,
    background: PrimaryColor,
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  closeButton: {
    color: Black,
  },
  modalContent: {
    marginTop: "5%",
  },
  detailGroup: {
    display: "flex",
    flexDirection: "row",
    width: "100% !important",
    alignItems: "center",
    padding: 0,
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
  },
  detailRow: {
    display: "flex",
    flexDirection: "column",
    width: "100% !important",
  },
  detailLabel: {
    fontWeight: "600",
  },
  detailValue: {
    width: "95% !important",
    border: "none",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    background: LightGrey,
    color: InputColor,
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
    "& div, input, button": {
      //child
      border: "none",
    },
  },
  input: {
    width: "95% !important",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    border: ".5px solid #7E7D7D",
    background: White,
    color: Black,
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
    "& div, input, button": {
      //child
      border: "none",
    },
  },
  buttonDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginTop: "5%",
    "@media (max-width: 640px)": {
      //flexDirection: "column",
    },
  },
  button: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "12rem",
    color: White,
    background: PrimaryColor,
    borderRadius: "10px",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "95% !important",
    margin: "0.5rem",
    padding: "0.5rem",
    borderRadius: "5px",
    background: LightGrey,
    border: ".5px solid #7E7D7D",
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
  },
  checkbox: {
    color: DarkGrey,
    "&.Mui-checked": {
      color: PrimaryColor,
    },
  },
  checkboxLabel: {
    marginLeft: "0.5rem",
    color: Black,
  },
  textarea: {
    width: "95% !important",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    border: ".5px solid #7E7D7D",
    background: White,
    color: Black,
    minHeight: "100px",
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
    "& div, input, button": {
      //child
      border: "none",
    },
  },
}));
